<script module lang="ts">
  import type { StatCardStoryblokProps } from './stat-card.types';
</script>

<script lang="ts">
  import { Card, CardContent } from '@agapi/ui/card';
  import { storyblokEditable } from '@storyblok/svelte';
  import { css } from '@agapi/ui/panda/css';

  const { blok }: StatCardStoryblokProps = $props();
</script>

<Card
  use={[[storyblokEditable, blok]]}
  spacing="normal"
  colorVariant={blok.colorVariant}
  css={{ height: 'full' }}
>
  <CardContent css={{ gap: '4' }}>
    <div class={css({ display: 'flex', flexDirection: 'column', gap: '1' })}>
      <span class={css({ textStyle: 'h2' })}>{blok.value} <span class={css({ color: "success.500" })}>{blok.unit}</span></span>
      <span class={css({ textStyle: 'h5' })}>{blok.label}</span>
    </div>
    {#if blok.description}
      <p class={css({ textStyle: 'body.sm', color: 'text.muted' })}>
        {blok.description}
      </p>
    {/if}
  </CardContent>
</Card>
